// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/DisabledReadOnly.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, view, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const DisabledReadOnly = () => <view.div css={{
  layout: 'column',
  gap: 'medium',
  '& > *': {
    width: css.value('350px')
  }
}}>
    <TextArea label="Disabled" defaultValue={EXAMPLE_TEXT} disabled />
    <TextArea label="Readonly" defaultValue={EXAMPLE_TEXT} readOnly />
  </view.div>;